module.exports = __webpack_public_path__ + "static/media/montserrat-latin-300-normal.bf00afac.woff";